import { render } from "./userView.vue?vue&type=template&id=0cba0f8d&scoped=true"
import script from "./userView.ts?vue&type=script&lang=js"
export * from "./userView.ts?vue&type=script&lang=js"

import "./userView.vue?vue&type=style&index=0&id=0cba0f8d&lang=scss&scoped=true"

import exportComponent from "I:\\Dev\\Projects\\LabManagement\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cba0f8d"]])

export default __exports__